// extracted by mini-css-extract-plugin
export var divider = "_mm-0";
export var systemMessage = "_mm-1";
export var systemMessageWrapper = "_mm-2";